import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
export default function (getValidated, getWarnings) {
    return function (value) {
        const validated = getValidated(value);
        const warnings = (getWarnings) ? getWarnings(value) : false;
        let className = (validated) ? '' : 'value-invalid';
        if (validated && warnings) {
            className = 'value-warning';
            return (React.createElement(OverlayTrigger, { placement: 'top', overlay: React.createElement(Tooltip, null, "This value must be greater than previous") },
                React.createElement("span", { className: className }, value)));
        }
        else {
            return (React.createElement("span", { className: className }, value));
        }
    };
}
;
